import { Component, OnDestroy, OnInit } from '@angular/core';
import {combineLatest, forkJoin} from 'rxjs';
import { FgjsService, ILivingComplex, ILivingComplexUser, IObject, IUser } from '../../users-fgjs/fgjs.service';
import { MatTableDataSource } from '@angular/material/table';
import {finalize, map, tap} from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AddObjectsComponent } from '../../components/add-objects/add-objects.component';

@Component({
  selector: 'app-users-dpm-list',
  templateUrl: './users-dpm-list.component.html',
  styleUrl: './users-dpm-list.component.scss'
})
export class UsersDpmListComponent implements OnInit, OnDestroy{
  displayedColumns = ['id', 'fullName', 'email', 'usersRoles', 'objectName', 'option'];
  users: MatTableDataSource<IUser>;
  mainUsers: IUser[] = [];
  loading = false;
  combined = null;
  selectedUserType = false;
  buildings: ILivingComplex[] = [];
  selectedComplexes: ILivingComplex[] = [];
  buildings2: ILivingComplex[] = [];
  users1: ILivingComplexUser[] = [];
  users2: IUser[] = [];

  constructor(
      public dialog: MatDialog,
      private serviceFgjs: FgjsService) {
    }

  ngOnInit() {
      this.loadList();
    }

  ngOnDestroy() {
    this.combined.unsubscribe();
  }

  loadList() {
      this.loading = true;
      this.combined = combineLatest([
        this.serviceFgjs.getUsers()
      ])
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe(res => {
          this.mainUsers = res[0];
          this.serviceFgjs.saveUsers.emit(this.mainUsers);
          this.selectUserType();
          this.selectComplexUser();
        });
  }

  selectUserType() {
    this.users = new MatTableDataSource(this.mainUsers.filter(f => f.roles.includes('DMP_Curator')));
    this.users2 = this.mainUsers.filter(f => f.roles.includes('DMP_Curator'));
  }

  applyFilter(event: Event) {
    this.users.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  openDialog(lastName: string, firstName: string, middleName: string, id: number, email: string) {
    const dialogRef = this.dialog.open(AddObjectsComponent, {
        height: '90%',
        width: '90%',
        data: {
          name: lastName+' '+firstName+' '+middleName,
          id: id,
          email: email,
          anchoredLvComplex: this.users1
          //complex: this.buildings
        }
      });

      dialogRef.componentInstance.complexesSelected.subscribe((complex: ILivingComplex[]) => {
        this.selectedComplexes = complex;
        this.updateComplexUser(id);
        this.loadList();
      });
    }

    selectComplexUser() {
      const observables = this.users.filteredData.map(f =>
        this.serviceFgjs.getComplexUser(f.userID)
      );

      forkJoin(observables).pipe(
        map(results => results.reduce((acc, curr) => acc.concat(curr), []))
      ).subscribe(res => {
        this.users1 = res;
        this.users1.forEach(f => {
          const user = this.users2.find(u => u.userID === f.userID);
          if (user) {
            this.updateUser(f.userID, f.livingComplexID);
          }
        })
      });
    }

    updateUser(id: number, complexId: number){
      const user = this.users2.find(u => u.userID === id);
      const complex = this.users1.find(c => c.livingComplexID === complexId);
      if (user && complex) {
        if (!user.livComplexes) {
          user.livComplexes = [];
        }
        user.livComplexes.push(complex.livingComplexTitle);
        this.mainUsers.push(user);
      }
    }

    updateComplexUser(id: number) {
        this.selectedComplexes.forEach(r => {
          this.serviceFgjs.addComplexUser(id, r.id)
        })
    }

    deleteComplex(id: number) {
      this.serviceFgjs.deleteComplexUser(id)
      .then(response => {
        if (response.status === 200) {
          this.loadList();
        } else {
          throw new Error('Error');
        }
      })
      .then(result => {
        //console.log(result);
      })
      .catch(error => {
        //console.error(error);
      });
    }

    truncateText(text: string): string {
      if (text.length <= 50) {
        return text;
      }
      return text.slice(0, 50) + '...';
    }
}
